import React from 'react';
import PropTypes from 'prop-types';

import { WIDGET_LIST } from '../widgets';

class PageRender extends React.Component {
  static renderPublicCanvas(widgets) {
    return widgets.map((widget, idx) =>
      React.createElement(
        WIDGET_LIST[widget.component],
        Object.assign({}, { key: idx }, widget.settings)));
  }

  constructor(props) {
    super(props);

    this.state = {
      page: this.props.page,
    };
  }

  renderCanvas(widgets) {
    return PageRender.renderPublicCanvas(widgets);
  }

  render() {
    return (
      <div>
        {this.renderCanvas(this.state.page.widgets)}
      </div>
    );
  }
}

PageRender.propTypes = {
  page: PropTypes.object.isRequired,
};

export default PageRender;
